module.exports = __webpack_public_path__ + "media/images/icons/grid-four-up-5534d3ba2f8da9a956eaa1b1c36b02a9.svg";